import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { IntegrationsService } from '@app/integrations/services/integrations.service';

export const integrationGuard = (): boolean | UrlTree => {
    const integrationsService = inject(IntegrationsService);
    const router = inject(Router);

    return integrationsService.isIntegration() && !integrationsService.isProperlyIntegrated()
        ? router.createUrlTree(['bad-request'])
        : true;
};
